import React from 'react';
import { isString } from 'underscore';
import { withDefaultStyles, type PropsWithDefaultStyle } from '@bingads-webui-react/with-default-styles';
import type { ClassesMap, I18nModel, IPalette } from './types';

export interface ITagContent {
  text: string;
  expDate: number;
}

const getMenuItemTagStyles = (_: unknown, { palette = {} }: { palette?: IPalette }) => ({
  menuItemTag: {
    backgroundColor: '#D83B01',
    color: palette.white,
    borderRadius: 12,
    padding: '0 7px',
    border: `1px solid ${palette.white}`,
    fontSize: 12,
    fontWeight: 'normal',
    height: 18,
    width: 'max-content',
    lineHeight: '14px',
    boxShadow: `0 2px 5px ${palette.neutralTertiary}`,
  },

  blueTag: {
    backgroundColor: '#F0F6FB',
    color: '#323130',
  },

  mccRecommendationTag: {
    marginLeft: '-2px',
  },
});

export type MenuItemTagProps = {
  classes: ClassesMap;
  tagContent: string | ITagContent;
  tagClass?: string;
  i18n?: I18nModel | null;
};

export class MenuItemTag extends React.PureComponent<MenuItemTagProps> {
  static defaultProps: Partial<MenuItemTagProps> = {
    tagClass: '',
  };

  render() {
    const {
      classes,
      tagContent,
      tagClass,
      i18n,
    } = this.props;
    if (!tagContent) {
      return (null);
    }
    if (!isString(tagContent)) {
      let {
        text,
      } = tagContent;
      const {
        expDate,
      } = tagContent;
      const today = Date.now();
      if (today > expDate || !i18n || !text) {
        return (null);
      }
      text = i18n.getString(text);
      return (
        <div className={`${classes.menuItemTag} ${classes[tagClass] || ''} menu-item-tag`}>{text}</div>
      );
    }
    // we should provide i18n if we provide the tagContent string
    return (
      <div className={`${classes.menuItemTag} ${classes[tagClass] || ''} menu-item-tag`}>{i18n ? i18n.getString(tagContent) : tagContent}</div>
    );
  }
}

MenuItemTag.defaultProps = {
  i18n: null,
};

export const StyledMenuItemTag: React.ComponentType<PropsWithDefaultStyle<MenuItemTagProps>> = withDefaultStyles(MenuItemTag, getMenuItemTagStyles);
